import displaysSideEffects from '../../../side-effects/menu/displays/displays-side-effects'
import _ from 'lodash'

export function cleanLocationSettingsDisplay (display, menuBlob, settingsBlob) {
  const availableDisplays = _.get(settingsBlob, 'displays', []).map(next => next.id)

  if (!availableDisplays.includes(display.id)) {
    const index = menuBlob.displays.indexOf(display)
    menuBlob.displays.splice(index, 1)
    displaysSideEffects.applySideEffects(display.id, menuBlob)
  }
}
